import { cn } from './cn'

export type SpinnerSize = 'sm' | 'md' | 'lg'

export interface SpinnerProps {
  size?: SpinnerSize
  /** スクリーンリーダー向けラベル。既定「読み込み中」 */
  label?: string
  className?: string
}

// 既存の `animate-spin rounded-full border-primary` 体裁をトークン化。
const SIZE: Record<SpinnerSize, string> = {
  sm: 'h-5 w-5 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-4',
}

/** ローディング表示の共通プリミティブ。role=status で読み上げに対応。 */
export function Spinner({ size = 'md', label = '読み込み中', className }: SpinnerProps) {
  return (
    <div role="status" className={cn('inline-flex flex-col items-center', className)}>
      <span
        aria-hidden="true"
        className={cn(
          'animate-spin rounded-full border-primary border-t-transparent',
          SIZE[size],
        )}
      />
      <span className="sr-only">{label}</span>
    </div>
  )
}
